module.exports = __webpack_public_path__ + "static/media/siemens-logo.c3edc3d2.svg";